import { render, staticRenderFns } from "./TransactionDetailHeaderSection.vue?vue&type=template&id=52185eb8&scoped=true"
import script from "./TransactionDetailHeaderSection.vue?vue&type=script&lang=js"
export * from "./TransactionDetailHeaderSection.vue?vue&type=script&lang=js"
import style0 from "./TransactionDetailHeaderSection.vue?vue&type=style&index=0&id=52185eb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52185eb8",
  null
  
)

export default component.exports